import { render, staticRenderFns } from "./SLBreakup.vue?vue&type=template&id=6bc5fe60&scoped=true"
import script from "./SLBreakup.vue?vue&type=script&lang=js"
export * from "./SLBreakup.vue?vue&type=script&lang=js"
import style0 from "./SLBreakup.vue?vue&type=style&index=0&id=6bc5fe60&prod&scoped=true&lang=scss"
import style1 from "./SLBreakup.vue?vue&type=style&index=1&id=6bc5fe60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc5fe60",
  null
  
)

export default component.exports